import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { antGrey, runwayColors } from '../styles/globalStyles';

interface TimelineEventCounterProps {
    previouslySeenCount: number;
}

export const TimelineEventCounter: React.FC<TimelineEventCounterProps> = ({ previouslySeenCount = 0 }) => {
    const fontSize = 12;

    const originalSizeToRoundedRectangleSizeRatio = 33.5 / 40; // based on figma design
    const isMoreThan99 = previouslySeenCount > 99;
    const count = previouslySeenCount + 1; // also considering the current event in the count

    if (count < 2) {
        return null;
    }

    return (
        <div
            style={{
                position: 'relative',
                display: 'block',
                width: 24,
                height: 24,
                lineHeight: 20,
                fontSize: fontSize,
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 24,
                    height: 20,
                    lineHeight: 20,
                    fontSize: fontSize,
                    borderRadius: 42, // based on Figma design
                    backgroundColor: antGrey.grey7,
                    bottom: 0,
                    left: 0,
                }}
            >
                <Text
                    style={{
                        fontSize: fontSize * (isMoreThan99 ? 0.6 : 1),
                        fontWeight: 600,
                        height: `${20 * originalSizeToRoundedRectangleSizeRatio - 2}px`,
                        lineHeight: `${20 * originalSizeToRoundedRectangleSizeRatio - 2}px`,
                        color: runwayColors.white,
                    }}
                >
                    {isMoreThan99 ? '99+' : count}
                </Text>
            </div>
        </div>
    );
};
